import React from "react";
import "./styles.scss";
import SyncLoader from "react-spinners/SyncLoader";

const Loading = () => {
  return (
    <div className="loading-wrapper animated fadeIn">
      <div className="loading">
        <h1>IEEE Innovation Nation</h1>
        <div className="spinner">
          <SyncLoader size={15} color={"#ffffff"} loading={true} />
        </div>
        <label>loading</label>
      </div>
    </div>
  );
};

export default Loading;
